export default "__VITE_ASSET__C17S8Zal__"